import { debounce } from 'lodash';
import React from 'react';
import { ProTable } from 'react-pro-components';
import { ProTableProps } from 'react-pro-components/typings/components/pro-table/types';
import { Modal } from 'ssc-ui-react';

import { $gt, VueCtxStore } from '@/common/appCtx';
import { dateToRegionalSecTs } from '@/utils/ts';

import api from './api';

interface SettingLogModelType {
  operation_time: any[];
  operation_start_time: number;
  operation_end_time: number;
  operator: string;
  operation: string;
}

const OperationMap: any = {
  0: 'Create',
  1: 'Edit',
  2: 'Delete',
};

const DeviceSettingLog = (props: any) => {
  const {
    showLogModal,
    setLogModal,
  } = props;

  const [dataSource, setDataSource] = React.useState<any[]>([]);
  const [pagination, setPagination] = React.useState({ current: 1, pageSize: 10, total: 0 });

  const [operatorOptions, setOperatorOptions] = React.useState([]);

  const fetchData = async(info: any) => {
    let start_time = undefined;
    let end_time = undefined;
    if (info.form.operation_time) {
      const [start, end] = info.form.operation_time;
      start_time = dateToRegionalSecTs(start * 1000);
      end_time = dateToRegionalSecTs(end * 1000);
    }
    const { data = {} } = await api.getDeviceSettingsLogList({
      ...info?.form,
      start_time,
      end_time,
      operation_time: undefined,
      pageno: info.pagination?.current || 1,
      count: info.pagination?.pageSize || 20,
    });
    const { list = [], pageno, count, total = 0 } = data;
    setDataSource(list.map((item: any) => {
      return {
        ...item,
        clock_in_devices: (item.clock_in_devices || []).join(',') || '-',
        clock_out_devices: (item.clock_out_devices || []).join(',') || '-',
      };
    }));
    setPagination({ current: pageno, pageSize: count, total });
  };

  const loadOperatorDropdownList = async(params: any) => {
    try {
      const res = await VueCtxStore.dispatch('loadAllOperators', params);
      const operators = res.list.map((item: any) => {
        return {
          value: item.email,
          label: item.email,
        };
      });
      setOperatorOptions(operators);
    } catch (error) {
      console.error(error);
    }
  };

  const proTableProps: ProTableProps<SettingLogModelType, any> = {
    searchForm: {
      fields: [
        {
          name: 'operation_time',
          label: $gt('Operation Time'),
          type: 'rangepicker',
          style: {
            width: '50%',
          },
        },
        {
          name: 'operator',
          label: $gt('Operator Email'),
          type: 'select',
          style: {
            width: '50%',
          },
          ctrlProps: {
            options: operatorOptions,
            onSearch: debounce((value) => {
              const params: any = {
                count: value
                  ? 100
                  : 50,
              };
              if (value) params.operator = value;
              loadOperatorDropdownList(params);
            }, 1000),
          }
        },
        {
          name: 'action_type',
          label: $gt('Operation'),
          type: 'select',
          style: {
            width: '50%',
          },
          ctrlProps: {
            options: [
              {
                label: 'Create',
                value: 0,
              },
              {
                label: 'Edit',
                value: 1,
              },
              {
                label: 'Delete',
                value: 2,
              },
            ],
          }
        },
      ],
      footerProps: { showReset: true },
    },
    table: {
      dataSource,
      columns: [
        {
          title: $gt('Operation Time'),
          dataIndex: 'operation_time_str',
          width: 150,
        },
        {
          title: $gt('Operator Email'),
          dataIndex: 'operator',
          width: 120,
          ellipsis: true,
          lineClamp: 1,
        },
        {
          title: $gt('Operation'),
          dataIndex: 'action_type',
          width: 80,
          render: (value) => {
            return OperationMap[value];
          },
        },
        {
          title: $gt('Station'),
          dataIndex: 'station_name',
          width: 100,
          ellipsis: true,
          lineClamp: 1,
        },
        {
          title: $gt('Clock-in Device'),
          dataIndex: 'clock_in_devices',
          width: 200,
          ellipsis: true,
          lineClamp: 1,
        },
        {
          title: $gt('Clock-out Device'),
          dataIndex: 'clock_out_devices',
          width: 200,
          ellipsis: true,
          lineClamp: 1,
        },
      ],
      scroll: {
        x: 1200,
      },
      pagination,
      rowKey: 'id',
    },
    fetchData,
  };

  return <>
    <Modal
      title={ $gt('Attendance Device Setting Log') }
      visible={showLogModal}
      width={1200}
      footer={null}
      onCancel={() => setLogModal(false)}
    >
      <ProTable {...proTableProps} />
    </Modal>
  </>;
};

export default DeviceSettingLog;
